import { fail } from "../infra/validation";
import type { FavouriteSitesRecord } from "../types";

const isSiteIds = (value: unknown): value is number[] =>
  Array.isArray(value) && value.every((id) => Number.isInteger(id));

export const assertValidSiteId = (siteId: number): void => {
  if (!Number.isInteger(siteId)) fail("favourite siteId must be an integer");
};

export const legacyFavouriteSites = (
  value: unknown,
): { rows: FavouriteSitesRecord[]; malformed: string[] } => {
  const entries =
    value && typeof value === "object" && !Array.isArray(value)
      ? Object.entries(value)
      : [];
  return {
    rows: entries
      .filter(([cognitoSub, siteIds]) => cognitoSub && isSiteIds(siteIds))
      .map(([cognitoSub, siteIds]) => ({ cognitoSub, siteIds })),
    malformed: entries
      .filter(([cognitoSub, siteIds]) => !cognitoSub || !isSiteIds(siteIds))
      .map(([cognitoSub]) => cognitoSub),
  };
};
